module.exports = __webpack_public_path__ + "img/img_lianghua_duichong@3x.b4facbdc.png";